import { findNumberPropertyNameWithValue } from 'calling-integration-sdk-support/remote-interface/utils/calleeOperators';
import PortalIdParser from 'PortalIdParser';
import { createDialNumberPayload } from 'calling-integration-sdk-support/utils/createDialNumberPayload';
import { getIn } from 'calling-integration-sdk-support/utils/getIn';
import { getLastSentThirdPartySubject, getLastSentThirdPartySubjectFromParent } from './windowUtils';
const initialFromSubject = {
  objectTypeId: '',
  objectId: 0,
  ownerId: 0,
  threadId: 0
};
export const getDialNumberFromOpenWidgetEvent = (openWidgetDetails, fromSubject = initialFromSubject) => {
  const portalId = PortalIdParser.get();
  const toSubject = openWidgetDetails.toSubject;
  if (!toSubject) return;
  const phoneNumberProperties = toSubject.phoneNumberProperties;
  const phoneNumberProperty = findNumberPropertyNameWithValue(phoneNumberProperties, toSubject.numberPropertyName);
  const validatedPhoneNumber = getIn(['metadata'], phoneNumberProperty) || {
    phoneNumber: '',
    extension: '',
    regionCode: 'US'
  };
  const propertyName = getIn(['propertyName'], phoneNumberProperty);
  const lastSentSubjectData = getLastSentThirdPartySubjectFromParent() || getLastSentThirdPartySubject();
  const fromSubjectData = lastSentSubjectData ? Object.assign({}, fromSubject, lastSentSubjectData) : fromSubject;
  return createDialNumberPayload({
    selectedCallee: toSubject,
    phoneNumber: validatedPhoneNumber.phoneNumber || '',
    extension: validatedPhoneNumber.extension || '',
    countryCode: validatedPhoneNumber.regionCode || '',
    selectedToNumberPropertyName: propertyName || '',
    subjectId: fromSubjectData.objectId,
    objectTypeId: fromSubjectData.objectTypeId,
    ownerId: fromSubjectData.ownerId || 0,
    portalId: portalId || 0,
    threadId: fromSubjectData.threadId || toSubject.threadId
  });
};